"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-magic-numbers */
const vue_demi_1 = require("vue-demi");
const common_1 = tslib_1.__importDefault(require("../assets/scripts/common"));
const request_1 = tslib_1.__importDefault(require("../assets/scripts/request"));
const utils_1 = require("../utils");
const locales_1 = tslib_1.__importDefault(require("./locales"));
const __sfc_main = {};
__sfc_main.props = {
    actSign: {
        key: "actSign",
        required: true,
        type: String
    },
    module: {
        key: "module",
        required: true,
        type: String
    },
    isPreGetPrizeParam: {
        key: "isPreGetPrizeParam",
        required: true,
        type: String
    },
    prizeRuleStatusParam: {
        key: "prizeRuleStatusParam",
        required: true,
        type: String
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const { useLang, useToast, useI18n } = require('@fegobull/webapi').use;
    const { lang } = useLang();
    const Toast = useToast();
    const { uid, jumpLogin, updateFegoVariable } = (0, common_1.default)();
    const $tran = useI18n(locales_1.default);
    const props = __props;
    const status = (0, vue_demi_1.reactive)({
        isPreGetPrize: false,
        canClaimPrizeList: [],
        seeBtnLink: '' // 查看按钮链接
    });
    const updatePrizeRuleStatus = () => {
        // 根据 rule_type 第一个值：
        // 1 单门槛取 plan_external_id，
        // 2 多门槛取 plan_external_id:api_rule_sign，并去重
        const rawList = status.canClaimPrizeList.map(item => {
            var _a;
            const { rule_type: ruleTypeArr, plan_external_id: planId, api_rule_sign: apiSign } = (_a = item === null || item === void 0 ? void 0 : item.can_get_prize_judge) !== null && _a !== void 0 ? _a : {};
            const firstRuleType = ruleTypeArr === null || ruleTypeArr === void 0 ? void 0 : ruleTypeArr[0];
            return firstRuleType === 2 ? `${planId}:${apiSign}` : planId;
        });
        const ruleStatusList = [...new Set(rawList)].join(',');
        updateFegoVariable(props.prizeRuleStatusParam, ruleStatusList);
    };
    (0, vue_demi_1.watch)(() => status, newStatus => {
        updateFegoVariable(props.isPreGetPrizeParam, newStatus.isPreGetPrize ? '1' : '0');
        updatePrizeRuleStatus();
    }, {
        deep: true,
        immediate: false
    });
    // 做lang的映射
    const langMap = {
        0: 'cn',
        1: 'hk',
        2: 'en',
        5: 'jp'
    };
    function getTitle(title) {
        const titleShow = title[langMap[lang]] || title[langMap[2]];
        return titleShow;
    }
    const isH5Page = (0, vue_demi_1.computed)(() => {
        return (0, utils_1.isH5)();
    });
    /**
     * 请求可领奖奖品列表
     */
    async function requestGetCanClaimPrizeList() {
        try {
            const { list, see_btn_link: seeBtnLink } = await request_1.default.getCanClaimPrizeList({
                config: {
                    actSign: props.actSign,
                    moduleName: props.module
                }
            });
            status.canClaimPrizeList = list; // 可领奖奖品列表
            status.isPreGetPrize = list.find(item => !item.isGet) ? 1 : 0; // 是否有可领奖奖品
            status.seeBtnLink = seeBtnLink;
        }
        catch (error) {
            console.error(error);
        }
    }
    /**
     * 领取单个奖励
     */
    async function requestClaimSinglePrize(prizeId) {
        try {
            Toast.loading(3);
            const { success } = await request_1.default.claimPrize({
                actSign: props.actSign,
                moduleName: props.module,
                apiPrizeSign: prizeId
            });
            if (success) {
                (0, vue_demi_1.nextTick)(() => {
                    requestGetCanClaimPrizeList();
                    Toast.success($tran('claimSinglePrizeSuccess'));
                });
            }
            else {
                Toast.error($tran('claimSinglePrizeFailed'));
            }
        }
        catch (error) {
            console.error(error);
            Toast.error($tran('claimSinglePrizeFailed'));
        }
    }
    /**
     * 一键领取所有奖励
     */
    async function requestClaimAllPrize() {
        try {
            Toast.loading({
                duration: 0
            });
            let successCount = 0;
            const preSendList = status.canClaimPrizeList.filter(item => !item.isGet);
            for (const prize of preSendList) {
                const { success } = await request_1.default.claimPrize({
                    actSign: props.actSign,
                    moduleName: props.module,
                    apiPrizeSign: prize.send_prize_key
                });
                if (success) {
                    // eslint-disable-next-line no-plusplus
                    successCount++;
                }
            }
            Toast.close();
            if (successCount === preSendList.length) {
                Toast.success($tran('claimAllPrizeSuccess'));
            }
            else {
                Toast.error($tran('claimAllPrizeFailed'));
            }
            (0, vue_demi_1.nextTick)(() => {
                requestGetCanClaimPrizeList();
            });
        }
        catch (error) {
            console.error(error);
            Toast.error($tran('claimAllPrizeFailed'));
        }
    }
    function toSeeReward() {
        // 执行到这里
        console.log('====================status.seeBtnLink', status.seeBtnLink);
        window.location.href = status.seeBtnLink;
    }
    (0, vue_demi_1.onMounted)(() => {
        if (uid) {
            requestGetCanClaimPrizeList();
        }
    });
    return Object.assign({
        uid,
        $tran,
        status,
        getTitle,
        isH5Page,
        requestClaimSinglePrize,
        toSeeReward
    }, {
        claimAllPrize: () => {
            if (!uid) {
                return jumpLogin();
            }
            requestClaimAllPrize();
        }
    });
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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